<template>
  <div>
    <v-row v-if="isAdmin">
      <v-col>
        <v-autocomplete
          :items="allCustomers"
          v-model="currentCompany"
          @click:clear="clearCompany"
          clearable
          outlined
          item-text="translatedName"
          item-value="id"
          :label="$t('common:customer')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-autocomplete
          :items="allTasks"
          v-model="selectedTask"
          clearable
          outlined
          item-text="name"
          item-value="id"
          :label="$t('common:task')"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import InfoService from '@/modules/core/services/info-service';
import Utils from '@/modules/core/services/utils';
import TaskBoardService from '@/modules/book/services/task-board-service';

export default {
  name: 'TaskList',
  data() {
    return {
      allCustomers: [],
      currentCompany: {},
      allTasks: [],
      selectedTask: {}
    }
  },
  watch: {
    selectedTask() {
      for (let i = 0; i < this.allTasks.length; i++) {
        if (this.allTasks[i].id === this.selectedTask ) {
          this.$emit('taskChanged', this.allTasks[i]);
          break;
        }
      }
    },
    currentCompany() {
      this.allTasks = [];
      this.selectedTask = {};
      this.loadTasks();
      this.$emit('customerIdChanged', this.currentCompany)
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters["auth/isAdmin"];
    }
  },
  methods: {
    loadCustomers() {
      InfoService.readOptionsByUrl('customer/all-customers',
          (customers) => {
            this.allCustomers = customers;
          },
          (error) => {
            this.$logger.error("Error at fetching all customers: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:customer_plural')}));
          }
      )
    },
    loadTasks() {
      if (!this.currentCompany || this.currentCompany === {}) return;
      TaskBoardService.loadTasks(
          this.currentCompany,
          (response) => {
            this.allTasks = response.data;
          },
          (error) => {
            this.$logger.error("Error at fetching all tasks: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:customer_plural')}));
          }
      );
    },
    clearCompany() {
      this.selectedTask = {};
      this.currentCompany = this.$store.state.auth.profile.customer;
    },
    updateData() {
      this.loadTasks();
    }
  },
  mounted() {
    if (this.isAdmin) {
      this.loadCustomers();
    }
    this.currentCompany = this.$store.state.auth.profile.customer;
    this.loadTasks();
  }
}
</script>